import JsonLd from "./JsonLd";
import { BUSINESS } from "@/config/business";

// Site-wide identity schema — same data as the static copy in index.html
// (search engines/AI crawlers that don't execute JS only see that one), kept
// here too for pages that render it client-side. Both read from the same
// BUSINESS config, so they can't drift apart.
export default function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: BUSINESS.legalName,
    alternateName: BUSINESS.alternateName,
    url: BUSINESS.url,
    logo: BUSINESS.logo,
    description: BUSINESS.description,
    foundingDate: BUSINESS.foundingDate,
    parentOrganization: {
      "@type": "Organization",
      name: BUSINESS.parentOrganization,
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: BUSINESS.address.streetAddress,
      addressLocality: BUSINESS.address.addressLocality,
      addressRegion: BUSINESS.address.addressRegion,
      postalCode: BUSINESS.address.postalCode,
      addressCountry: BUSINESS.address.addressCountry,
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: BUSINESS.phones[0],
      contactType: "customer service",
      email: BUSINESS.email,
      availableLanguage: BUSINESS.languages,
    },
    sameAs: Object.values(BUSINESS.socialLinks),
    geo: {
      "@type": "GeoCoordinates",
      latitude: BUSINESS.geo.latitude,
      longitude: BUSINESS.geo.longitude,
    },
    areaServed: {
      "@type": "Country",
      name: "India",
    },
  };

  return <JsonLd data={schema} />;
}
